module.exports = __webpack_public_path__ + "img/cut_xl2.f507c52a.jpg";